import FormFieldChooseGroup from "../../components/FormFieldChooseGroup/FormFieldChooseGroup";
import FormFieldHidden from "../../components/FormFieldHidden/FormFieldHidden";
import FormFieldInputText from "../../components/FormFieldInputText/FormFieldInputText";
import FormFieldMultiSelect from "../../components/FormFieldMultiSelect/FormFieldMultiSelect";
import FormFieldSelect from "../../components/FormFieldSelect/FormFieldSelect";
import { CustomerData } from "../CustomerData/CustomerData";

export enum OrderDataFields {
    TRACKINGCONSENT = "trackingConsent",
    AGB = "agb",
    PLUSOPTION = "plusOption"
}

export interface OrderDataProducts {
    magicNumber: string,
    numberOfLicences?: number,
    paymentPeriod?: string,
    additionalParameters: Record<string, string>
}

export type OrderData = {
    [key in OrderDataFields]?: string | boolean;
} & {
    products?: OrderDataProducts[],
    customer?: CustomerData
    captchaToken?: string
};

export interface OrderDataFieldConfiguration {
    required: boolean;
    ref?: FormFieldChooseGroup 
        | FormFieldInputText
        | FormFieldSelect
        | FormFieldHidden
        | FormFieldMultiSelect;
}

export type OrderDataFieldConfigurations = {
    [key in OrderDataFields]: OrderDataFieldConfiguration;
}